import { ref } from "vue";
const bus = ref(new Map());

export default function useEventsBus() {
  function emitt(event: string, ...args: any[]) {
    bus.value.set(event, args);
  }

  return {
    emitt,
    bus,
  };
}
